import React from "react";
import { BulletsLabel } from "../styled/referral-styled";

const BulletDisplay = ({ amount }: { amount: number }) => {
  return <BulletsLabel>You have {amount} bullets, want more?</BulletsLabel>;
};

export default BulletDisplay;
